import { z } from 'zod';

export const CompileSeveritySchema = z.enum(['error', 'warning', 'info']);

export const CompileDiagnosticSchema = z.object({
  severity: CompileSeveritySchema,
  node_id: z.string().nullable(),
  message: z.string(),
});

export const CompiledProgramSchema = z.object({
  program_id: z.string().min(1),
  bytecode: z.array(z.number().int().min(0).max(255)),
  instruction_count: z.number().int().nonnegative(),
  estimated_scan_us: z.number().int().nonnegative(),
  diagnostics: z.array(CompileDiagnosticSchema),
});

export type ParsedCompiledProgram = z.infer<typeof CompiledProgramSchema>;
